import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import EditOutlinedSvg from "@ant-design/icons-svg/es/asn/EditOutlined";
import AntdIcon from "../components/AntdIcon";
var EditOutlined = function EditOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: EditOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  EditOutlined.displayName = 'EditOutlined';
}
export default /*#__PURE__*/React.forwardRef(EditOutlined);